import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import Order from "../components/Order";


const OrdersList = () => {
    const navigate = useNavigate();


    useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
        }
        else {
            navigate('/unauthorize');
        }

    }, []);


    return (
        <React.Fragment >
            <Order />
        </React.Fragment>
    );
};

export default OrdersList;